import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { Checkbox, Stack, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LanguageIcon from '@mui/icons-material/Language';

import { CustomMenuItem, Menu } from "../menu/menu";
import { useGlobalContext } from "../../provider";

interface LanguageMenuProps {
	onClose?: any
}

interface LanguageListType {
	key: string
	value: string
}

const languageList: LanguageListType[] = [
	{ key: 'en', value: 'English' },
	{ key: 'jp', value: '日本語' }
]

const LanguageMenu = ({ onClose }: LanguageMenuProps) => {
	const [{ lang }, { dispatch }]: GlobalContextType = useGlobalContext();
	const [menuEL, setMenuEL] = useState<null | HTMLElement>(null);

	const onOpenMunu = (event: React.MouseEvent<HTMLElement>) => {
		setMenuEL(event.currentTarget);
	}

	const onCloseMenu = () => {
		setMenuEL(null);
		if (onClose) onClose();
	}

	const onChangeLang = (item: LanguageListType) => {
		if (item.key !== lang) {
			dispatch({ lang: item.key })
		}
	}

	return (
		<React.Fragment>
			<LanguageSelectWrapper className="menu-item-container language-select" onClick={onOpenMunu}>
				<LanguageIcon fontSize="small" />
				<Typography variant="body1">{lang}</Typography>
				<ArrowDropDownIcon fontSize="medium" />
			</LanguageSelectWrapper>

			<Menu anchorEl={menuEL}
				open={Boolean(menuEL)} onClose={onCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
				transformOrigin={{ vertical: 'top', horizontal: 'right', }}
				PaperProps={{ sx: { mt: 4 } }}
			>
				<LanguageMenuWrapper onClick={onCloseMenu}>
					{languageList.map((item: LanguageListType, key: number) => (
						<CustomMenuItem key={key}
							className="language-item"
							onClick={() => { onChangeLang(item) }}
						>
							<Checkbox size="small" checked={item.key === lang} />
							<Typography variant="body1">{item.value}</Typography>
						</CustomMenuItem>
					))}
				</LanguageMenuWrapper>
			</Menu>
		</React.Fragment>
	)
}

const LanguageSelectWrapper = styled(Stack)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "space-between",
	minWidth: 110,

	cursor: "pointer",
	padding: theme.spacing(1, 1.5),
	borderRadius: theme.spacing(10),
	backgroundColor: theme.palette.common.mainBg,
	border: `1px solid ${theme.palette.common.firstBorder}`,

	p: {
		paddingLeft: 3,
		fontWeight: 500,
		textTransform: 'uppercase',
		color: `${theme.palette.common.firstColor}d0`
	},

	svg: {
		height: "100%",
		color: `${theme.palette.common.firstColor}d0`
	},

	'&:hover': {
		opacity: 0.75,
	},

}))

const LanguageMenuWrapper = styled(Stack)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",

	minWidth: 150,
	borderRadius: 10,
	background: theme.palette.common.white,
	// border: `1px solid ${theme.palette.common.menuBorder}`,

	'.language-item': {
		gap: theme.spacing(0),
		padding: theme.spacing(0, 1),
		borderRadius: theme.spacing(1),

		svg: {
			padding: 'unset !important',
			color: theme.palette.common.firstColor,
		}
	}
}))

export { LanguageMenu }